import type { FaireProductEntity } from "../../entity_types/product";

export const p_cjtkaggzkh: FaireProductEntity = {
  token: "p_cjtkaggzkh",
  type: "product",
  name: "Essential Oil Sprays Lavender/Rosemary/Eucalyptus/Rose/Ylang",
  brandToken: "b_7jqwqwjp5c",
  brandName: "Aromalee Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/7411fc5f9f3c25069ba71a5fd8f14763962bfdaf78a8c1a4c782be9359843cce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed8d39b029c39395529513aed8a9ab194ab69c6a018996a5f839834e2db3690e.jpeg",
    "https://cdn.faire.com/fastly/1800f5b0c3ccb5ec9cefd87a1fe35b9ab3345e3d5cf147e422cbe7cf61257605.jpeg",
    "https://cdn.faire.com/fastly/17ea1d5fd74145770b9736af9da135dd86d2fc10926775062daef9e4561991dd.jpeg",
    "https://cdn.faire.com/fastly/0343ea9f691a81e326fc429f78ae69971f983470979b8ca7710121852a1fa945.jpeg",
    "https://cdn.faire.com/fastly/8341543a59162499ee525fef8cdaecbfe1d03c21f403b8d8bb0b44d4522fedc7.jpeg",
  ],
  priceDollars: 15.24,
  description:
    "Our essential oil room sprays can be used as a personal perfume, room spray, and linen refresher!\n\nChoose from any of our 5 staple scents!\n\nCONFIDENCE 💛\n▫️Scented With Ylang Ylang, Rosemary, & Jasmine Essential Oils\n\nLOVE 💖\n▫️Scented With Rose, Sage, & Geranium Essential Oils\n\nFOCUS 💙\n▫️Scented With Peppermint & Eucalyptus Essential Oils\n\nSTRESS RELIEF 💜\n▫️Scented with Lavender & Rosemary Essential Oils\n\nPURIFY 🧡\n▫️Scented With Sweet Orange, Tangerine, & Lemon Essential Oil\n\nHand Poured in a 4oz Amber Bottle With Distilled Water, Witch Hazel, and Essential Oils.",
  tags: [],
  msrpDollars: 30.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:37.720Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
